export default "__VITE_PUBLIC_ASSET__c0f417b6__"